export enum OccasionType {
  INVITE = 'INVITE',
  TRAINING = 'TRAINING',
}
